import { FC } from 'react';

interface Props {
  top?: string;
  left?: string;
  bottom?: string;
  transform?: string;
  width?: string;
  height?: string;
}

const EyeBrow: FC<Props> = ({
  top = '7',
  left = '52',
  transform = '15',
  bottom = '0',
  width = '23',
  height = '12',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 23 12"
      fill="none"
      style={{
        position: 'relative',
        top: `${top}`,
        left: `${left}`,
        bottom: `${bottom}`,
        transform: `rotate(${transform}deg)`,
        zIndex: 1,
      }}
    >
      <path
        d="M0.663819 0.0843424C3.15684 -0.204297 9.40626 0.0887935 14.8922 3.52401C18.0821 5.52161 20.4352 8.10157 22.0072 10.3278C22.2459 10.6661 22.1656 11.1341 21.8273 11.373C21.4891 11.6117 21.0211 11.5311 20.7821 11.1931C19.296 9.08854 17.0804 6.66392 14.0969 4.79555C8.9702 1.58509 3.0844 1.31426 0.836485 1.5745C0.425034 1.62213 0.0527337 1.3272 0.00507496 0.915752C-0.0425616 0.504308 0.252387 0.132012 0.663819 0.0843424Z"
        fill="white"
      />
    </svg>
  );
};

export default EyeBrow;
